import { useTranslation } from '@sib/i18n';
import { ConfirmationDialog } from '@sib/ui';

interface LogoutDialogProps {
  isOpen: boolean;
  handleClose: () => void;
  onLogout: () => void;
}

export const LogoutDialog = ({
  onLogout,
  isOpen,
  handleClose,
}: LogoutDialogProps) => {
  const { t } = useTranslation();

  return (
    <ConfirmationDialog
      open={isOpen}
      onClose={handleClose}
      onConfirm={() => {
        onLogout();
        handleClose();
      }}
      title={t('logout.title')}
      description={t('components.defaultLayout.logOutConfirmation')}
      DialogContentProps={{
        className: 'w-[650px] items-center flex flex-col gap-6',
      }}
      ConfirmButtonProps={{
        label: t('logout.title'),
        className: 'w-48',
      }}
      CancelButtonProps={{
        className: 'w-48',
      }}
    />
  );
};
